import Reveal from "./Reveal";
import { SERVICES } from "../../data/pwt";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-12 items-end mb-16 md:mb-20">
          <Reveal className="col-span-12 md:col-span-7">
            <span className="overline">02 — What we do</span>
            <h2 className="mt-6 font-serif text-4xl md:text-6xl tracking-tight text-[#0A140F] leading-[1.02]">
              The full spectrum of
              <br />
              <span className="italic text-[#1A402B]">business transformation.</span>
            </h2>
          </Reveal>
          <Reveal className="col-span-12 md:col-span-5" delay={120}>
            <p className="md:pl-10 font-sans text-lg leading-relaxed text-[#415248]">
              The PWT ecosystem covers all aspects of business transformation,
              supporting clients through present and future challenges.
            </p>
          </Reveal>
        </div>

        <div className="border-t border-[#E5EBE6]">
          {SERVICES.map((service, i) => (
            <Reveal
              key={service.number}
              delay={i * 40}
              data-testid={`service-row-${service.number}`}
              className="group grid grid-cols-12 gap-6 border-b border-[#E5EBE6] py-8 md:py-10 hover:bg-[#F8F9F8] transition-colors"
            >
              <div className="col-span-12 md:col-span-2 font-mono text-sm text-[#1A402B] tracking-widest">
                {service.number}
              </div>
              <div className="col-span-12 md:col-span-5">
                <h3 className="font-serif text-2xl md:text-3xl text-[#0A140F] leading-snug group-hover:text-[#1A402B] transition-colors">
                  {service.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-5">
                <p className="font-sans text-base leading-relaxed text-[#415248]">
                  {service.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
